import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../store";
import { getInsuranceById, updateInsurance } from "../modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    currentInsurance: state.insuranceReducer.insuranceToEdit,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      updateInsurance,
      getInsuranceById,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
